<template>
  <div v-show="!hidden" :class="small ? 'd-inline-block': 'row'">
    <div class="my-auto text-center" :class="!small && 'col-12'">
      <div class="loader text-center" :class="loader_classes">
        <!-- the actual spinner -->
        <b-spinner :small="small" />
        <div v-if="loadingText && !small">
          <!-- eslint-disable-next-line vue/no-v-html -->
          <span v-html="loadingText" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    hidden: {
      type: Boolean,
      required: false,
      default: false,
    },
    height: {
      type: String,
      required: false,
      default: '100%',
    },
    width: {
      type: String,
      required: false,
      default: '100%',
    },
    loadingText: {
      type: String,
      required: false,
      default: null,
    },
    additionalLoaderClasses: {
      type: Array,
      required: false,
      default: () => [],
    },
    small: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    loader_classes() {
      return this.additionalLoaderClasses.join(' ');
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
